module.exports = __webpack_public_path__ + "static/mielikki-DND3_FnP-4942b829e4e179efa7f2b0eab6baeff1.jpg";